import { render, staticRenderFns } from "./viewBuildingBrowseView.vue?vue&type=template&id=18b3a872&scoped=true"
import script from "./viewBuildingBrowseView.vue?vue&type=script&lang=js"
export * from "./viewBuildingBrowseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b3a872",
  null
  
)

export default component.exports